import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Component from '../components/Types/index'
import { setType, fetchTypes } from '../ducks/types'

function mapStateToProps(state) {
  const me = state.me
  
  return {
    types: state.types.list,
    fetched: state.types.fetched,
    type: state.types.selected,
    projectId: (me && typeof me === 'object') ? ((me.project && typeof me.project === 'object') ? me.project.id : me.project) : null
  }
}

function mapDispatchToProps(dispatch) {
  const actions = { setType, fetchTypes, push }
  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/Types.js